import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'

type CancelVisitDialogProps = {
  identifier?: string | null
  onSubmit: () => Promise<void>
}

export const CancelVisitDialog: FC<CancelVisitDialogProps> = ({ identifier, onSubmit }) => {
  const theme = useMinimalsTheme()
  const { dialogStore } = usePlanningStore()
  const { t } = useTranslate()

  return (
    <>
      <DialogTitle>
        {identifier
          ? t('cancelVisitNumberX', 'Cancel visit {number}', {
              number: identifier,
            })
          : t('cancelVisit', 'Cancel visit')}
        ?
      </DialogTitle>
      <DialogContent>
        <DialogContentText mb={theme.customSpacing.m}>
          {t(
            'cancelVisitWarningLine1',
            'Cancelling this visit will remove all related information.',
          )}
        </DialogContentText>
        <DialogContentText>
          {t(
            'cancelVisitWarningLine2',
            "You can reactivate the visit by selecting 'Reactivate visit'. The status will be set to 'Expected' and all related information will be enabled.",
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          data-cy='confirm-close-visit-btn'
          onClick={async () => {
            await onSubmit()
          }}
        >
          {t('yesCancel', 'Yes, cancel')}
        </Button>
        <Button variant='text' color='secondary' onClick={() => dialogStore.close()}>
          {t('noKeepVisit', 'No, keep visit')}
        </Button>
      </DialogActions>
    </>
  )
}
